
$(document).ready(function() {

    function updateSlides() {
        let maxHeight = 170;
        $('#products-swiper .slide-footer').each(function (idx, el) {
            let slideDescHeight = $(el).find('.slide-desc').outerHeight() + 75;
            if (slideDescHeight > maxHeight) {
                maxHeight = slideDescHeight;
            }
        })
        $('#products-swiper .slide-footer').css('height', maxHeight + 'px')
    }

    setTimeout(() => {
        updateSlides();
    }, 300)

    $(window).on('resize', function () {
        updateSlides();
    })


});
